import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';

@Component({
    selector: 'ms-instances-selection',
    templateUrl: './instances-selection.component.html',
    styleUrls: ['./instances-selection.component.scss'],
})
export class InstancesSelectionComponent implements OnInit {
    @Output() instanceSelectedDescri = new EventEmitter<string>();
    @Output() instanceSelectedValue = new EventEmitter<string>();
    @Input() productID = '';
    public cmsObj: CmsObject[];
    public selectedInstanceKey: string = '';
    public instanceDescription: string = '';
    public instanceValue: string = '';
    public language: string='';
    public instanceInfo: string='';
    constructor(public magoWebService: MagoWebService, public storeRoleService: StoreRolesService,   public cmsService: CmsService,private workflow: WorkFlowService,) {}

    ngOnInit(): void {
      this.getCmsObj();
        this.magoWebService.getDefaultSettingsFromDB();
    }

    public async onInstanceChange(event: any) {
        this.instanceDescription = this.magoWebService?.instances.find((x) => x.InstanceKey == event.value)?.Description;
        this.instanceValue = event.value;
        this.selectedInstanceKey = event.value;
        this.magoWebService.selectedInstanceKey = this.selectedInstanceKey;
        this.instanceSelectedValue.emit(event.value);
        this.instanceSelectedDescri.emit(this.instanceDescription);
    }

    async getCmsObj() {
      this.language = this.workflow.getLanguageForCms();
      this.cmsObj = await this.cmsService.getCmsObj(this.language, 'myUsers');
      this.instanceInfo = this.cmsObj.find((x) => x.ContentName == 'myUsers_instanceKeyInfo').ContentTranslation;

  }
}
